import { render } from "./TopCountryStatistic.vue?vue&type=template&id=5fae85c1&scoped=true"
import script from "./TopCountryStatistic.vue?vue&type=script&lang=js"
export * from "./TopCountryStatistic.vue?vue&type=script&lang=js"

import "./TopCountryStatistic.vue?vue&type=style&index=0&id=5fae85c1&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fae85c1"]])

export default __exports__